export const API_URL = process.env.REACT_APP_API_URL
export const LOGIN_URL = `/auth/login`
export const REGISTER_URL = `/register`
export const DASHBOARD_URL = `/users/dashboard`
export const CATEGORIES_URL = `/categories`
export const ADD_PRODUCT_URL = `/products`
export const PRODUCTS_URL = `/products`

export const DELETE_PRODUCT_URL = `/products/{id}`

export const CUSTOMER_PRODUCTS_URL = `/customers/product`
export const UPLOAD_PRODUCT_IMAGE_URL = `/products/{id}/upload`